import MobileViewSupplierInfoContainer from "./Containers/MobileViewSupplierInfoContainer";
export default MobileViewSupplierInfoContainer;
